module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/chess-rook.svg?659d0805d37e2b4711cd11e6b7af7c0d";